export const BATCH_CREATE_ANALYSIS_RESPONSE = {
  OperationResult: 'OperationResult',
  TokenError: 'TokenError',
  Unauthorized: 'Unauthorized',
  WrongInputs: 'WrongInputs',
};
